import React, { Component } from "react";
import locales from "../../../_constants/locales";
import "../styles/TicketErrorPage.css";

class TicketErrorPage extends Component {
    render() {
        return (
            <section className="fit layout vertical center-center fetch-error-page">
                <h1 className="title">There was a problem getting information</h1>
                <span className="thick-divider" />
                <p className="description">Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.</p>
                <p className="help-message">
                    {`Keep seeing this message? Go to `}
                    <a href={"https://help.kobo.com"} className="help-link">
                        {"help.kobo.com"}
                    </a>
                </p>
            </section>
        );
    }
}

export default TicketErrorPage;
